var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 71.52 71.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke:#fff;}.cls-1,.cls-2{stroke-width:0.5px;}.cls-2{fill:#d68828;stroke:#d68828;stroke-linecap:round;stroke-linejoin:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2209",
    "data-name": "Group 2209"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    className: "cls-1",
    d: "M53.09,59.29H24a2.77,2.77,0,0,1-2.76-2.76V45.23a1.14,1.14,0,0,1,2.27,0h0v11.3A.48.48,0,0,0,24,57H53.07a.48.48,0,0,0,.48-.48v-42a.47.47,0,0,0-.48-.48H24a.47.47,0,0,0-.48.48v11.3a1.14,1.14,0,0,1-2.27,0V14.55A2.76,2.76,0,0,1,24,11.79H53.09a2.75,2.75,0,0,1,2.76,2.76h0v42a2.77,2.77,0,0,1-2.76,2.76Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    className: "cls-2",
    d: "M35.32,43.14a1.14,1.14,0,0,1-.8-2l5.67-5.67-5.67-5.67a1.14,1.14,0,0,1,1.61-1.61l7.27,7.31-7.27,7.27A1.15,1.15,0,0,1,35.32,43.14Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    className: "cls-2",
    d: "M41.78,36.68H15.93a1.14,1.14,0,0,1,0-2.27H41.78a1.14,1.14,0,0,1,0,2.27Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.80f20c9d7a28e8cb64dce1943b1c72ab.svg";
export { ForwardRef as ReactComponent };